import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { Icon } from '../Icon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var NormalFontSvg = function NormalFontSvg() {
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/_jsxs("g", {
      fill: "#000",
      clipPath: "url(#prefix__a)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M7.54 1 0 23.177l1.484.505 2.382-7.006h4.967v-1.568H4.4l4.264-12.54h2.43l1.063 3.126 1.484-.505L12.216 1z"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        d: "M14.479 6.532h3.862L24 23.177l-1.484.505-1.771-5.21h-8.67l-1.771 5.21-1.484-.505zm-1.871 10.373h7.604L17.218 8.1h-1.617z",
        clipRule: "evenodd"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "prefix__a",
        children: /*#__PURE__*/_jsx("path", {
          fill: "#fff",
          d: "M0 0h24v24H0z"
        })
      })
    })]
  });
};
export var NormalFont = function NormalFont(props) {
  return /*#__PURE__*/_jsx(Icon, _objectSpread(_objectSpread({}, props), {}, {
    component: NormalFontSvg
  }));
};